import ConstrainBase from "../ConstrainBase";
import ValidationResult from "../ValidationResult";

/**
 * class NotBlankConstrain
 * Stellt sicher dass ein Wert nicht leer ist.
 * analog zur serverseitigen NotBlankConstrain.php
 */
class NotBlankConstrain extends ConstrainBase {

  validate(value) {
    if (value === null || value === undefined || value === '') {
      return new ValidationResult(false, 'Dieses Feld darf nicht leer sein.');
    }
    return new ValidationResult(true, '');
  }
}

export default NotBlankConstrain;
